umpApp.onReady = function () {
    console.log('onReady: ');
    // console.log('this: ', this);

    // skip intro 3d
    //hide intro
    // $("#intro").css({ "display": "none" });
    // //display site web
    // $("#full-width-page-wrapper").css({ "display": "block", "top": "0px", "overflow-y": "visible" });
    // $("body, html").css({ "overflow-y": "visible" });
    // umpApp.initSite.init();

    this.introBuild.init();

};